module.exports = __webpack_public_path__ + "img/Superb_sword_05.a29bed75.png";